const burgerMenu = () => {

	const burgerBtn = document.querySelector('[data-btn="burger-menu"]'),
		  navbar 	= document.querySelector('.hdr-nav');

	burgerBtn.addEventListener('click', ()=>{
		navbar.classList.add('active');
		navbar.classList.add('slide-left-long');
		addEventListener('click', closeMenu);
	});

	navbar.addEventListener('click', (e) => {
		let target = e.target;

		if(target.classList.contains('close-modal')) {
			navbar.classList.remove('active');
			navbar.classList.remove('slide-left-long');
			removeEventListener('click', closeMenu);
		}

		if(target.classList.contains('title-link') || target.parentNode.classList.contains('arrow-down')) {
			e.preventDefault();


			let parentBlock = target.closest('.arrow-down');
			let submenu = parentBlock.querySelector('.submenu');

			if(parentBlock.classList.contains('active')) {
				parentBlock.classList.remove('active');
				submenu.style.height = '0px';
			} else {
				parentBlock.classList.add('active');
				submenu.style.height = submenu.scrollHeight + 'px';
			}

		}

		if(target.dataset.btn == 'geo-mobile') {
			let geoBtn = document.querySelector('[data-btn="geo-modal"]');

			console.log(geoBtn)

			geoBtn.click();
			navbar.classList.remove('active');
			navbar.classList.remove('slide-left-long');
			removeEventListener('click', closeMenu);
		}

		// console.log(target)
	});

	// закрыть по клику вне окна
	function closeMenu(event) {
		let target = event.target;

		if(!navbar.contains(target) && target.dataset.btn != 'burger-menu') {
			navbar.classList.remove('active');
			navbar.classList.remove('slide-left-long');
			removeEventListener('click', closeMenu);
		}
	}
}

export default burgerMenu;